import { apiSlice } from "features/api/apiSlice";
import { transformDoctor } from "./transformDoctor";

const getDoctors = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getDoctors: build.query({
      query: ({ page = 1, perPage = 10, search, filter, isPremium }) => {
        const params = new URLSearchParams({
          page,
          limit: perPage,
          ...(search && { fullname: search }),
          ...(filter && { specializations: filter }),
          ...(isPremium && { joinSubscription: true }),
        });

        return `/doctors/mwell?${params}`;
      },
      transformResponse: (res) => {
        const { data, count } = res.d;

        return { data: data.map(transformDoctor), count };
      },
    }),
  }),
});

export const { useGetDoctorsQuery } = getDoctors;
